export default "__VITE_ASSET__Dann5y_K__"